export default [
  "Accounting",
  "Financing",
  "Prospecting",
  "Renovating",,
  "Property Management",
  "Other"
]
